import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';

import IncidentListContainer from './IncidentListContainer';
import MapContainer from '../../MapContainer';

class IncidentListView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Fragment>
        <div className="list-col">
          <IncidentListContainer
            style={{ flex: '1 0 200px', height: '100%' }}
          />
        </div>
        <div
          className="map-col"
          style={{
            display: this.props.map.mapColumnVisible ? '' : 'none',

          }}
        >
          <MapContainer />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  map: state.map
});

export default connect(mapStateToProps)(IncidentListView);



// WEBPACK FOOTER //
// ./src/components/incidents/IncidentList/index.js